import type { FC } from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { PapiSellerDiscount } from '@wix/da-papi-types';
import { getAppliesToBabelKey } from '../SellerDiscountModal/_partials/DiscountPreviewCard/helpers';

import s from './DiscountCategoryLabels.scss';

interface Props {
  discount: PapiSellerDiscount;
  className?: string;
}

const DiscountCategoryLabels: FC<Props> = ({ discount, className }) => {
  const { t } = useTranslation();

  const appliesToString = t(
    getAppliesToBabelKey(
      discount.appliesto === 'any_tier' ? 'subscriptions' : 'shop_products',
      discount.appliesto
    )
  );

  const audienceString = t(
    `studio.discountModal.form.audienceInput.option.${discount.audience}`
  );
  return (
    <div className={c(s['discount-labels'], className)}>
      <div>{appliesToString}</div>
      <div className={s['label-divider']} />
      <div>{audienceString}</div>
    </div>
  );
};
DiscountCategoryLabels.displayName = 'DiscountCategoryLabels';

export default DiscountCategoryLabels;
